// TermsAndConditions.js
import React from 'react';
import '../styles.css';

const TermsAndConditions = () => {
  return (
    <div className="legal-links">
      <h1>Terms & Conditions</h1>
      <p>
        Welcome to GETFITFAST! By accessing or using this website, you agree to be bound by the following terms and conditions. If you do not accept these terms, please discontinue use of the site immediately.
      </p>

      <h2>1. Intellectual Property Rights</h2>
      <p>
        All content, including text, images, and other materials available on this website, is owned by GETFITFAST or its licensors unless otherwise stated. You may use this content for personal and non-commercial purposes only. Any unauthorized use, reproduction, or redistribution of the content is strictly prohibited.
      </p>

      <h2>2. User Responsibilities</h2>
      <p>
        By using this site, you agree not to:
      </p>
      <ul>
        <li>Engage in any activities that disrupt or damage the website.</li>
        <li>Use the website for unlawful, fraudulent, or harmful purposes.</li>
        <li>Attempt to gain unauthorized access to the website or its features.</li>
        <li>Post or distribute any offensive, defamatory, or harmful content through the site.</li>
      </ul>

      <h2>3. Limitation of Liability</h2>
      <p>
        GETFITFAST is not liable for any direct or indirect damages arising from your use of the website. This includes, but is not limited to, loss of data, profits, or other intangible losses resulting from:
      </p>
      <ul>
        <li>Your use or inability to use the site.</li>
        <li>Third-party content or conduct on the website.</li>
        <li>Errors, inaccuracies, or omissions in the content.</li>
        <li>Unauthorized access to or misuse of your information.</li>
      </ul>

      <h2>4. Third-Party Services</h2>
      <p>
        This site may display ads and links from third-party providers like Google AdSense. GETFITFAST is not responsible for the content, policies, or practices of third-party websites. Please review the terms and policies of third-party services before engaging with them.
      </p>

      <h2>5. Modifications</h2>
      <p>
        We reserve the right to modify these terms and conditions at any time. Changes will take effect upon posting on this page. Continued use of the site after changes constitutes your acceptance of the updated terms.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions or concerns about these terms, please contact us at:
      </p>
      <p>Email: getfitfast1901@gmail.com</p>
    </div>
  );
};

export default TermsAndConditions;
